import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, Drawer, Button, Image, Flex } from 'antd';
import './index.scss';
import { getRecoil } from 'recoil-nexus';
import { checkPermissions } from '../../utils/permissions';
import { translateThis } from '../../helpers/language.helper';
import SVGIcons from '../../assets/images/icons/svgIcons';
import AppIcons from '../../assets/images/icons';

import { getCurrentFacilityURL } from '../../helpers/helper.functions';
import HeaderRightUserInfo from '../headerRightUserInfo';
import { appConfigAtomState } from '../../state/reducerAtoms/app.atom';

const { Item } = Menu;


const AppHeader = () => {
    const appState = getRecoil(appConfigAtomState);
    const profile = appState?.profile || {};
    const facilityURL = getCurrentFacilityURL();
    const [isMobile, setIsMobile] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 490);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const scrollToSection = (id) => {
        const section = document.getElementById(id);
        if (section) {
            const top = section.getBoundingClientRect().top + window.scrollY; // Get the absolute position
            window.scrollTo({
                top,
                behavior: 'smooth',
            });
        }
    };


    const myNavItems = [];

    if (checkPermissions(profile, "See Agents")) {
        myNavItems.push({
            title: translateThis("AI Agents"),
            // icon: SVGIcons.HomeIcon(),   
            link: `/${facilityURL}/ai-development/modules`,
            key: 'aiDev',
        })
    }
    if (checkPermissions(profile, "See Tickets")) {
        myNavItems.push({
            title: translateThis("Tickets"),
            // icon: SVGIcons.ProductIcon(),
            link: `/${facilityURL}/ai-development/tickets`,
            key: 'tickets',
        })
    }
    if (checkPermissions(profile, "View Dashboard")) {
        myNavItems.push({
            title: translateThis("Dashboard"),
            // icon: SVGIcons.ProductIcon(),
            link: `/${facilityURL}/dashboard`,
            key: 'dashboard',
        })
    }
    if (checkPermissions(profile, "See Admin Users")) {
        myNavItems.push({
            title: translateThis("Admin users"),
            // icon: SVGIcons.ProductIcon(),
            link: `/${facilityURL}/admin-users`,
            key: 'adminUsers',
        })
    }
    if (checkPermissions(profile, "See Intents")) {
        myNavItems.push({
            title: translateThis("Intents"),
            // icon: SVGIcons.ProductIcon(),
            link: `/${facilityURL}/intents`,
            key: 'intents',
        })
    }


    if (!checkPermissions(profile, "See Admin Users") && !checkPermissions(profile, "See Agents")
        && !checkPermissions(profile, "View Dashboard") && !checkPermissions(profile, "View Tickets")) {
        // myNavItems.push({
        //     title: translateThis("No Access"),
        //     // icon: SVGIcons.ProductIcon(),
        //     link: `/${facilityURL}/no-access`,
        //     key: 'noAccess',
        // })
    }
    // const selectedKeys = myNavItems
    //     .filter(item => (
    //         (location.pathname.startsWith(item.link) && item.link !== '/' && location.pathname !== '/') ||
    //         (item.link === '/' && location.pathname === '/')
    //     ))
    //     .map(item => item.key);

    const pathname = location.pathname.toLowerCase();

    const selectedKeys = myNavItems
        .filter(item => {
            const link = item.link.toLowerCase();

            // Match specific keywords
            const isModule = pathname.includes('module') && link.includes('module');
            const isTicket = pathname.includes('ticket') && link.includes('ticket');

            return isModule || isTicket;
        })
        .map(item => item.key);


    const menuItems = myNavItems.map((element, index) => ({
        key: element.key,
        // icon: element.icon,
        label: <Link key={index} className={(location.pathname) === element.link ? 'active' : ''} to={element.link}>{element.title}</Link>,
    }));

    // const menuItems = (
    //     <Menu
    //         className='page-main-nav'
    //         mode={isMobile ? 'vertical' : 'horizontal'}
    //         style={{ border: 'none', width: '100%' }}
    //     >
    //         <Item key="aiDev"><Link to={`/${facilityURL}/ai-development/modules`}>{translateThis('AI-dev')}</Link> </Item>
    //         <Item key="tickets"><Link to={`/${facilityURL}/ai-development/tickets`}>{translateThis('Tickets')}</Link> </Item>
    //     </Menu>
    // );

    return (
        <>
            <Flex horizontal="true" justify={'space-between'} align={'center'} style={{ width: '100%' }} gap={'15px'} >
                <Link to={'/'} className="logo">
                    <img className="main-logo" src={AppIcons.logo} alt={'Pnp Logo'} />
                </Link>
                <Menu className='page-main-nav'
                    mode={isMobile ? 'vertical' : 'horizontal'}
                    style={{ border: 'none', width: '100%' }} selectedKeys={selectedKeys} items={menuItems} />
                {/* {menuItems} */}
                <HeaderRightUserInfo />
            </Flex>
        </>
    );
};

export default AppHeader;